/** Finish reasons that mean the model stopped before finishing (desktop parity). */
export const TRUNCATION_FINISH_REASONS = ['length', 'max_tokens', 'content_filter'] as const

export const WEB_CHAT_CONTINUE_PROMPT =
  'Please continue from where you left off. Output only the continuation, no repetition or preamble.'

export function isTruncatedAssistantFinishReason(finishReason: string | null | undefined): boolean {
  if (finishReason == null || finishReason === '') return false
  return (TRUNCATION_FINISH_REASONS as readonly string[]).includes(finishReason)
}
